import { render, staticRenderFns } from "./TaskActions.vue?vue&type=template&id=318642b3"
import script from "./TaskActions.vue?vue&type=script&lang=js"
export * from "./TaskActions.vue?vue&type=script&lang=js"
import style0 from "./TaskActions.vue?vue&type=style&index=0&id=318642b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports